import { Text } from '@northladder/i18n';

import { translations } from '../../../translations';

interface IButtonCancelCameraProps {
  onClick: () => void;
}

/**
 * -----------------------------------------------------------------------------
 * Renders a button which on press dismisses the entire camera capture modal.
 */
export function ButtonCancelCamera({ onClick }: IButtonCancelCameraProps) {
  return (
    <button
      className="form-btn-secondary w-auto border border-gray-300 text-gray-700"
      onClick={onClick}
      type="button"
    >
      <Text text={translations.cropping.cancel} />
    </button>
  );
}
